import styled from "@emotion/styled";

export const Content = styled.div<{ alignRight?: boolean }>(
    props =>
        props.alignRight && {
            float: "right",
            marginTop: 5,
        }
);
